import {ActionList} from '@primer/react'
import {FailureDialog} from '../FailureDialog'
import {StateIcon} from '../StateIcon'
import type {DefaultError, UseMutationResult} from '@github-ui/react-query'
import {announce} from '@github-ui/aria-live'
import {useConvertToDraftMutation} from '@github-ui/mergebox/use-convert-to-draft-mutation'
import {useOptimisticPrStateCallbacks} from '../../hooks/use-invalidate-pr-state'

const mutateOptions = {onSuccess: () => announce('Pull request converted to draft')}

export function useConvertToDraftActionMutation() {
  return useConvertToDraftMutation(useOptimisticPrStateCallbacks('DRAFT'))
}

export function ConvertToDraftAction({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return (
    <ActionList.Item loading={mutation.isPending} onSelect={() => mutation.mutate(undefined, mutateOptions)}>
      <ActionList.LeadingVisual>
        <StateIcon state="DRAFT" />
      </ActionList.LeadingVisual>
      Convert to draft
    </ActionList.Item>
  )
}

export function ConvertToDraftFailureDialog({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return mutation.isError ? (
    <FailureDialog
      title="Failed to convert to draft"
      message="An error occurred while converting this pull request to a draft. Please try again."
      details={mutation.error.message}
      onRetry={() => mutation.mutate(undefined, mutateOptions)}
      onDismiss={() => mutation.reset()}
    />
  ) : null
}
